export default {
    methods: {
        addRouteSource(route) {
            const sourceId = `route-${route.id}`;
            this.mySmartMap.addSource(sourceId, {
                type: 'geojson',
                data: {
                    type: 'Feature',
                    properties: {},
                    geometry: {
                        type: 'MultiLineString',
                        coordinates: route.coordinates
                    }
                }
            });
        },
        addRouteLayer(route) {
            const sourceId = `route-${route.id}`;
            this.mySmartMap.addLayer({
                id: sourceId,
                type: 'line',
                source: sourceId,
                paint: {
                    'line-color': route.line_color,
                    'line-width': parseFloat(route.line_width)
                }
            });
        },
        showRoute(route) {
            const sourceId = `route-${route.id}`
            this.mySmartMap.once('moveend', () => {
                if (!this.mySmartMap.getSource(sourceId)) {
                    this.addRouteSource(route);
                }
                if (!this.mySmartMap.getLayer(sourceId)) {
                    this.addRouteLayer(route);
                } else {
                    this.mySmartMap.setLayoutProperty(sourceId, 'visibility', 'visible');
                }
            })
        },
        hideRoute(route) {
            const sourceId = `route-${route.id}`;
            this.mySmartMap.setLayoutProperty(sourceId, 'visibility', 'none');
        }
    }
};